import initialState from "./InitialStates";
import Actions from "../actions/Actions";
import update from "immutability-helper";
import {message} from "antd";

message.config({
    top: 70,
    maxCount: 2,
});

const MerchantReducer = (state = initialState.merchant, action) => {
    switch (action.type) {
    case Actions.MERCHANT_DETAIL_REQUEST:
        return update(state, {loading: {$set: true}});
    case Actions.MERCHANT_DETAIL_SUCCESS:
        localStorage.setItem("m_id", action.payload.clientId);
        return update(state, {
            loading: {$set: false},
            id: {$set: action.payload.clientId},
            apiKey: {$set: action.payload.key},
            endPoint: {$set: action.payload.endpoint},
            publicKey: {$set: action.payload.publicKey},
            privateKey: {$set: action.payload.privateKey}
        });
    case Actions.MERCHANT_DETAIL_FAIL:
        return update(state, {loading: {$set: false}});
    case Actions.MERCHANT_DETAIL_RESET:
        localStorage.removeItem("m_id");
        return update(state, {
            isLoading: {$set: false}, 
            loading: {$set: false},
            id: {$set: ""}, 
            apiKey: {$set: ""}, 
            endPoint: {$set: ""},
            privateKey: {$set: ""},
            publicKey: {$set: ""}
        });

    case Actions.MERCHANT_APIKEY_REQUEST:
        return update(state, {isLoading: {$set: true}});
    case Actions.MERCHANT_APIKEY_SUCCESS:
        message.success(action.message, 5);
        return update(state, {isLoading: {$set: false}, apiKey: {$set: action.payload}});
    case Actions.MERCHANT_APIKEY_EXIST:
        message.warning(action.message, 5);
        return update(state, {isLoading: {$set: false}, apiKey: {$set: action.payload}});
    case Actions.MERCHANT_APIKEY_FAIL:
        message.error(action.message, 5);
        return update(state, {isLoading: {$set: false}});

    case Actions.MERCHANT_PUB_KEY_REQUEST:
        return update(state, {isDownloadPublic: {$set: true}});
    case Actions.MERCHANT_PUB_KEY_SUCCESS:
        return update(state, {isDownloadPublic: {$set: false}, publicKey: {$set: action.payload}});
    case Actions.MERCHANT_PUB_KEY_NOTFOUND:
        return update(state, {isDownloadPublic: {$set: false}, publicKey: {$set: ""}});
    case Actions.MERCHANT_PUB_KEY_FAIL:
        message.error("Unable to download Public Key.", 5);
        return update(state, {isDownloadPublic: {$set: false}});

    case Actions.MERCHANT_PRI_KEY_REQUEST:
        return update(state, {isDownloadPrivate: {$set: true}});
    case Actions.MERCHANT_PRI_KEY_SUCCESS:
        return update(state, {isDownloadPrivate: {$set: false}, privateKey: {$set: action.payload}});
    case Actions.MERCHANT_PRI_KEY_NOTFOUND:
        return update(state, {isDownloadPrivate: {$set: false}, privateKey: {$set: ""}});
    case Actions.MERCHANT_PRI_KEY_FAIL:
        message.error("Unable to download Private Key.", 5);
        return update(state, {isDownloadPrivate: {$set: false}});

    case Actions.MERCHANT_KEY_GEN_REQUEST:
        return update(state, {isKeyGenerate: {$set: true}});
    case Actions.MERCHANT_KEY_GEN_SUCCESS:
        return update(state, {isKeyGenerate: {$set: false}, privateKey: {$set: action.payload}});
    case Actions.MERCHANT_KEY_GEN_FAIL:
        message.error("Unable to generate Private Key", 5);
        return update(state, {isKeyGenerate: {$set: false}, privateKey: {$set: ""}});

    case Actions.MERCHANT_SET_ENDPOINT_REQUEST:    
        return update(state, {isUpdateEndpoint: {$set: true}});
    case Actions.MERCHANT_SET_ENDPOINT_SUCCESS:  
        return update(state, {isUpdateEndpoint: {$set: false}, endPoint: {$set: action.payload.endpoint}});
    case Actions.MERCHANT_SET_ENDPOINT_FAIL: 
        message.error("Unable to set endpoint.", 5);   
        return update(state, {isUpdateEndpoint: {$set: false}});

    default:
        return state;
    }
};

export default MerchantReducer;